// =============================================================================
// MeuDriver — Batch U2: Hook de onboarding do instrutor
// =============================================================================

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { toast } from 'sonner'
import type { OnboardingStatus, OnboardingStepKey } from '@/types/database'

// ---------------------------------------------------------------------------
// Query key
// ---------------------------------------------------------------------------

export const onboardingKeys = {
  all: ['instructor-onboarding'] as const,
  status: () => [...onboardingKeys.all, 'status'] as const,
}

// ---------------------------------------------------------------------------
// useOnboardingStatus
// ---------------------------------------------------------------------------

export function useOnboardingStatus() {
  return useQuery<OnboardingStatus | null>({
    queryKey: onboardingKeys.status(),
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_onboarding_status')
      if (error) throw error
      const row = (data as OnboardingStatus[] | null)?.[0] ?? null
      return row
    },
    staleTime: 1000 * 60 * 5,
  })
}

// ---------------------------------------------------------------------------
// useUpdateOnboardingStep
// ---------------------------------------------------------------------------

export function useUpdateOnboardingStep() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      step,
      completed,
    }: {
      step: OnboardingStepKey
      completed: boolean
    }) => {
      const { error } = await supabase.rpc('update_onboarding_step', {
        p_step: step,
        p_completed: completed,
      })
      if (error) throw error
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingKeys.all })
    },
    onError: (err: Error) => {
      toast.error('Erro ao atualizar onboarding: ' + err.message)
    },
  })
}
